class ProductPlaylist extends HTMLElement {
  constructor() {
    super();
    this.playlistItemList = this.querySelectorAll('.list-song');
    this.list = this.querySelector('ol.product__tracklist-list');
    this.audioPlayer = document.querySelector('audio-player');
    this.tracklist = this.getTracklist();
    this.init();
  }

  init() {
    this.playlistItemList.forEach(song => {
      song.onclick = function () {
        if (this.dataset.type == 'collection') {
          this.audioPlayer.setPlaylist(this.tracklist);
          this.audioPlayer.init();
        }
        this.songIndex = parseFloat(song.dataset.trackNumber);
        if (song.classList.contains('playing')) {
          this.audioPlayer.player.pause();
        } else {
          if (song.classList.contains('paused')) {
            this.audioPlayer.player.play();
          } else {
            this.audioPlayer.collectionPlaylist = this;
            this.audioPlayer.player.skipTo(this.songIndex);
          }
        }
      }.bind(this);
    });
  }

  getTracklist() {
    return JSON.parse(this.querySelector('.metafield-json').textContent);
  }
}

export default ProductPlaylist; 